import React, { createContext, useContext } from 'react';
import type { IssueViewFormApi } from '../../apis/issue-view-form-api.tsx';

type ProviderProps = {
	children: React.ReactNode;
	api: IssueViewFormApi;
};

const IssueViewFormApiContext = createContext<IssueViewFormApi | null>(null);

export const IssueViewFormApiProvider = ({ children, api }: ProviderProps) => (
	<IssueViewFormApiContext.Provider value={api}>{children}</IssueViewFormApiContext.Provider>
);

export const useIssueViewFormApi = () => {
	const api = useContext(IssueViewFormApiContext);

	if (!api) {
		throw new Error('useIssueViewFormApi must be used within a IssueViewFormApiProvider');
	}

	return api;
};
